export default __webpack_public_path__ + "static/media/TourGuidePage_01.e1cc016c.jpg";